<template>
  <div class="icon-header">
    <div class="icon">
      <i class="fas" :class="'fa-' + icon"></i>
    </div>
    <span>
        <slot />
    </span>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.icon-header{
  font-size: 0.875rem;
  display: flex;
  align-items: center;
  font-weight: 700;

  .icon{
    width: 1.5em;
    margin-right: 0.25rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
